// Fase 3 i18n bundle — carbon footprint terminology GL + ES
import i18n from "@/i18n";

const GL = {
  title: "Pegada de Carbono",
  subtitle: "Motor MRV de emisións · GHG Protocol · ISO 14064",
  tab_resumo: "Resumo",
  tab_vehicle: "Por vehículo",
  tab_concello: "Por concello",
  tab_factors: "Factores",
  tab_whatif: "What-if",
  scope1: "Ámbito 1",
  scope2: "Ámbito 2",
  scope3: "Ámbito 3",
  total_co2e: "Total CO₂e",
  intensity: "Intensidade kg CO₂e/t",
  no_weighins: "Sen pesaxes neste período",
  km_total: "Km totais",
  vehicles_active: "Vehículos activos",
  co2e_avoided: "CO₂e evitado vs baseline",
  vs_baseline: "vs. base {{year}}",
  provisional: "",
  demo_fleet: "",
  no_data_available: "Sen datos operativos aínda",
  no_data_tooltip: "Aínda non hai vehículos con telemetría activa integrada. Os datos aparecerán automaticamente cando o provedor GPS conecte a frota.",
  traceability: "Trazabilidade",
  traceability_title: "Trazabilidade MRV",
  formula: "Fórmula",
  factor: "Factor de emisión",
  factor_source: "Fonte",
  factor_version: "Versión",
  factor_valid_from: "Válido dende",
  computed_at: "Calculado o",
  source: "Fonte",
  version: "Versión",
  category: "Categoría",
  scope: "Ámbito",
  value: "Valor",
  unit: "Unidade",
  active: "Activo",
  new_factor: "Novo factor",
  edit_factor: "Editar factor",
  history: "Historial",
  view_history: "Ver historial",
  view_traceability: "Ver trazabilidade",
  simulate_title: "What-if · Simulación de renovación de flota",
  simulate_intro: "Simula o impacto en emisións de mudar o combustible dos vehículos. Baseado nos factores oficiais versionados.",
  simulate_disclaimer: "Simulación indicativa. Non substitúe estudos técnicos de viabilidade.",
  baseline_period: "Período base",
  current_fuel: "Combustible actual",
  new_fuel: "Novo combustible",
  simulate_action: "Simular",
  saving: "Simulando...",
  baseline: "Base",
  simulated: "Simulado",
  delta: "Diferenza",
  export_pdf: "Exportar PDF",
  weighins_title: "Pesaxes",
  weighins_subtitle: "Rexistro de pesaxes por vehículo, concello e ruta",
  weighin_new: "Novo pesaxe",
  weighin_upload_csv: "Subir CSV",
  weighin_download_template: "Descargar plantilla CSV",
  weighin_date: "Data",
  weighin_plate: "Matrícula",
  weighin_concello: "Concello",
  weighin_route: "Ruta",
  weighin_kg: "kg",
  weighin_source: "Orixe",
  weighin_source_onboard: "A bordo",
  weighin_source_scale: "Báscula",
  weighin_source_manual: "Manual",
  weighin_notes: "Notas",
  weighin_saved: "Pesaxe rexistrado",
  weighin_bulk_result: "{{inserted}} de {{total}} filas cargadas",
  restricted_role: "Sen permisos para esta sección",
  admin_only: "Só ADMIN",
  admin_supervisor_only: "ADMIN e SUPERVISOR",
  no_fleet: "Aínda non hai vehículos con telemetría activa integrada. Os datos aparecerán automaticamente cando o provedor GPS conecte a frota.",
  vehicle_plate: "Matrícula",
  vehicle_fuel: "Combustible",
  vehicle_km: "Km",
  vehicle_litres: "Litros estimados",
  vehicle_kgco2e: "kg CO₂e",
  concello_name: "Concello",
  concello_percapita: "kg CO₂e/hab",
  method: "Método",
  method_body: "Cando non hai telemetría real do consumo, estimamos litros = km × consumo_medio, e kgCO₂e = litros × factor oficial (MITECO/IPCC). O factor é un snapshot inmutable no momento do cálculo (MRV/ISO 14064).",
  cta_pegada: "Abrir Pegada",
  cta_pesaxes: "Abrir Pesaxes",
  sidebar_pegada: "Pegada",
  sidebar_pesaxes: "Pesaxes",
  simulate_ok: "Simulación completada",
  simulate_error: "Erro ao simular. Tenta de novo.",
  pdf_loading: "Xerando PDF…",
  pdf_ok: "PDF xerado correctamente",
  pdf_error: "Erro ao xerar o PDF",
  cancel: "Cancelar",
  factor_delete_title: "Borrar factor de emisión",
  factor_delete_body: "Isto borrará o factor «{{code}}» de forma permanente. Só se pode borrar se non foi usado en cálculos (integridade MRV / ISO 14064). Continuar?",
  factor_delete_confirm: "Borrar factor",
  factor_delete_aria: "Borrar factor {{code}}",
  factor_deleted: "Factor «{{code}}» borrado",
  factor_delete_409: "Non se pode borrar: o factor xa foi usado nun cálculo de pegada (integridade MRV ISO 14064).",
  factor_delete_404: "O factor non existe",
  factor_delete_error: "Erro ao borrar o factor",
};

const ES = {
  title: "Huella de Carbono",
  subtitle: "Motor MRV de emisiones · GHG Protocol · ISO 14064",
  tab_resumo: "Resumen",
  tab_vehicle: "Por vehículo",
  tab_concello: "Por municipio",
  tab_factors: "Factores",
  tab_whatif: "What-if",
  scope1: "Alcance 1",
  scope2: "Alcance 2",
  scope3: "Alcance 3",
  total_co2e: "Total CO₂e",
  intensity: "Intensidad kg CO₂e/t",
  no_weighins: "Sin pesajes en este período",
  km_total: "Km totales",
  vehicles_active: "Vehículos activos",
  co2e_avoided: "CO₂e evitado vs baseline",
  vs_baseline: "vs. base {{year}}",
  provisional: "",
  demo_fleet: "",
  no_data_available: "Sin datos operativos aún",
  no_data_tooltip: "Aún no hay vehículos con telemetría activa integrada. Los datos aparecerán automáticamente cuando el proveedor GPS conecte la flota.",
  traceability: "Trazabilidad",
  traceability_title: "Trazabilidad MRV",
  formula: "Fórmula",
  factor: "Factor de emisión",
  factor_source: "Fuente",
  factor_version: "Versión",
  factor_valid_from: "Válido desde",
  computed_at: "Calculado el",
  source: "Fuente",
  version: "Versión",
  category: "Categoría",
  scope: "Alcance",
  value: "Valor",
  unit: "Unidad",
  active: "Activo",
  new_factor: "Nuevo factor",
  edit_factor: "Editar factor",
  history: "Historial",
  view_history: "Ver historial",
  view_traceability: "Ver trazabilidad",
  simulate_title: "What-if · Simulación de renovación de flota",
  simulate_intro: "Simula el impacto en emisiones de cambiar el combustible de los vehículos. Basado en los factores oficiales versionados.",
  simulate_disclaimer: "Simulación indicativa. No sustituye estudios técnicos de viabilidad.",
  baseline_period: "Período base",
  current_fuel: "Combustible actual",
  new_fuel: "Nuevo combustible",
  simulate_action: "Simular",
  saving: "Simulando...",
  baseline: "Base",
  simulated: "Simulado",
  delta: "Diferencia",
  export_pdf: "Exportar PDF",
  weighins_title: "Pesajes",
  weighins_subtitle: "Registro de pesajes por vehículo, municipio y ruta",
  weighin_new: "Nuevo pesaje",
  weighin_upload_csv: "Subir CSV",
  weighin_download_template: "Descargar plantilla CSV",
  weighin_date: "Fecha",
  weighin_plate: "Matrícula",
  weighin_concello: "Municipio",
  weighin_route: "Ruta",
  weighin_kg: "kg",
  weighin_source: "Origen",
  weighin_source_onboard: "A bordo",
  weighin_source_scale: "Báscula",
  weighin_source_manual: "Manual",
  weighin_notes: "Notas",
  weighin_saved: "Pesaje registrado",
  weighin_bulk_result: "{{inserted}} de {{total}} filas cargadas",
  restricted_role: "Sin permisos para esta sección",
  admin_only: "Solo ADMIN",
  admin_supervisor_only: "ADMIN y SUPERVISOR",
  no_fleet: "Aún no hay vehículos con telemetría activa integrada. Los datos aparecerán automáticamente cuando el proveedor GPS conecte la flota.",
  vehicle_plate: "Matrícula",
  vehicle_fuel: "Combustible",
  vehicle_km: "Km",
  vehicle_litres: "Litros estimados",
  vehicle_kgco2e: "kg CO₂e",
  concello_name: "Municipio",
  concello_percapita: "kg CO₂e/hab",
  method: "Método",
  method_body: "Cuando no hay telemetría real de consumo, estimamos litros = km × consumo_medio, y kgCO₂e = litros × factor oficial (MITECO/IPCC). El factor es un snapshot inmutable en el momento del cálculo (MRV/ISO 14064).",
  cta_pegada: "Abrir Huella",
  cta_pesaxes: "Abrir Pesajes",
  sidebar_pegada: "Huella",
  sidebar_pesaxes: "Pesajes",
  simulate_ok: "Simulación completada",
  simulate_error: "Error al simular. Inténtalo de nuevo.",
  pdf_loading: "Generando PDF…",
  pdf_ok: "PDF generado correctamente",
  pdf_error: "Error al generar el PDF",
  cancel: "Cancelar",
  factor_delete_title: "Borrar factor de emisión",
  factor_delete_body: "Esto borrará el factor «{{code}}» de forma permanente. Solo se puede borrar si no ha sido usado en cálculos (integridad MRV / ISO 14064). ¿Continuar?",
  factor_delete_confirm: "Borrar factor",
  factor_delete_aria: "Borrar factor {{code}}",
  factor_deleted: "Factor «{{code}}» borrado",
  factor_delete_409: "No se puede borrar: el factor ya ha sido usado en un cálculo de huella (integridad MRV ISO 14064).",
  factor_delete_404: "El factor no existe",
  factor_delete_error: "Error al borrar el factor",
};

i18n.addResourceBundle("gl", "common", { fase3: GL }, true, true);
i18n.addResourceBundle("es", "common", { fase3: ES }, true, true);

export default {};
